module.exports = __webpack_public_path__ + "img/selected0-min.aed3f63a.png";